import { h } from "omi";

import { IconProps } from "@/components";

export function MinusCircleIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#a)">
        <path
          d="M6.66602 9.99935h6.66668m5 0c0 4.60235-3.731 8.33335-8.33335 8.33335-4.60237 0-8.33333-3.731-8.33333-8.33335 0-4.60237 3.73096-8.33333 8.33333-8.33333 4.60235 0 8.33335 3.73096 8.33335 8.33333Z"
          stroke="currentColor"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
